import axios from 'axios'
import { PROVIDER_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getAll(page, filter) {
    const params = {
        page,
        filter
    }

    return axios.get(PROVIDER_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function get(id) {
    const url = `${PROVIDER_URL}/${id}`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function create(provider) {
    return axios.post(PROVIDER_URL, provider, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function update(id, provider) {
    const url = `${PROVIDER_URL}/${id}`

    return axios.put(url, provider, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function deleteProvider(id) {
    const url = `${PROVIDER_URL}/${id}`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/provider.js